"use client";
import React from 'react';
import {ActiveEditorProvider} from "@inscript/lexical-editor";

interface TemplateSettingsDialogProps {
  title: string;
  onClose: () => void;
  onSave: () => void;
  children: React.ReactNode;
  enableLocaleTabs?: boolean;
}

const TemplateSettingsDialog: React.FC<TemplateSettingsDialogProps> = ({ 
  title, 
  onClose, 
  onSave, 
  children
}) => {
  return (
    <ActiveEditorProvider>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 100 }}>
        <div style={{ background: 'white', padding: '20px', borderRadius: '5px', minWidth: '300px' }}>
          <h2>{title}</h2>
          <div>{children}</div>
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
            <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded mr-2" onClick={onClose} style={{ marginRight: '10px' }}>Cancel</button>
            <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={onSave}>Save</button>
          </div>
        </div>
      </div>
    </ActiveEditorProvider>
  );
};

export default TemplateSettingsDialog;